export default "__VITE_ASSET__Ct9hcXa4__"